var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataSync(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.03 1.372a3.917 3.917 0 013.912 3.913V6.78a.652.652 0 11-1.304 0V5.285a2.608 2.608 0 00-2.609-2.609H7.811a2.608 2.608 0 00-2.609 2.609v9.13a2.608 2.608 0 002.609 2.608h4.742a.652.652 0 010 1.304H7.81a3.913 3.913 0 01-3.913-3.913v-9.13a3.916 3.916 0 013.913-3.912h6.218zm3.737 11.832l1.565.004c.28.001.514.21.549.486a.541.541 0 01-.022.34 4.087 4.087 0 01-3.79 2.567 4.1 4.1 0 01-3.793-2.6.556.556 0 011.035-.403c.295.769.899 1.38 1.665 1.682 1.24.49 2.656.095 3.462-.968h-.67a.555.555 0 010-1.108zM16.075 8.69a4.073 4.073 0 013.78 2.596.552.552 0 01-.316.717.535.535 0 01-.2.04.558.558 0 01-.517-.353 2.963 2.963 0 00-5.127-.717h.671a.555.555 0 010 1.108v.003l-1.565-.004a.619.619 0 01-.526-.825 4.073 4.073 0 013.8-2.565zm-5.591-.636a.652.652 0 010 1.304H7.51a.652.652 0 010-1.304h2.973zm2.336-2.986a.652.652 0 010 1.305H7.51a.652.652 0 010-1.305h5.31z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSync);
export default __webpack_public_path__ + "static/assets/dataSync.d43d5cc5.svg";
export { ForwardRef as ReactComponent };